namespace GeniuzPOS.QRreport {
    export namespace QDayDataService {
        export const baseUrl = 'QRreport/QDayData';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<QDayDataRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<QDayDataRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "QRreport/QDayData/Retrieve",
            List = "QRreport/QDayData/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>QDayDataService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
